import { AxiosResponse } from 'axios';

export function requestHeader(response: AxiosResponse|undefined, header: string){
  let headerValue = '';
  if(response){
    if (response?.headers[header]) {
      headerValue = response.headers[header];
    }
  }
  return headerValue;
}
